import * as React from 'react'
import {Component, ReactElement, ReactNode} from 'react'
import NatCondominiumRepo from '../../condominium/repository/NatCondominiumRepo'
import NatCondominiumGroupRepo from '../../condominiumGroup/repository/NatCondominiumGroupRepo'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../../components/shared/hoc/createAdminPage'
import NatRidgeRepo from '../../ridge/repository/NatRidgeRepo'
import NatRoomNumberRepo from '../../roomNumber/repository/NatRoomNumberRepo'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../../components/shared/hoc/withAdminPageTemplate'
import {TableRowName} from '../../../../styledComponents/adminPage/Table'
import {AdminPrimaryButton} from '../../../../styledComponents/adminPage/Buttons'
import {LeftRowFlexContainer} from '../../../../styledComponents/FlexComponents'
import {BackLink} from '../../../../styledComponents/adminPage/Links'
import PPTextField from '../../../../components/shared/forms/PPTextField'
import {Messages} from '../../../../Messages'
import {Nullable} from '../../../../app/TypeHelpers'
import {RoomNumberInfo} from '../../roomNumber/repository/NatGetAdminRoomNumberList'
import {NatPostOwnershipTransfers, NatPostOwnershipTransfersParams} from '../repository/NatPostOwnershipTransfers'
import {NatOwnershipTransfersRepo} from '../repository/NatOwnershipTransfersRepo'
import {MESSAGE_TYPE, SELECT_CONDOMINIUM_TYPE, USE_FUNCTION_ID} from '../../../../CodeMaster'
import {convertToRoomNumberForResident} from '../../../common/util/Natutil'
import NatTargetRoomNumberSelectionComponent from './NatTargetRoomNumberSelectionComponent'
import NatCondominiumSelectionComponent from '../../common/admin/NatCondominiumSelectionComponent'
import {CondominiumInfo} from '../../condominium/repository/NatGetCondominiumList'
import PPErrorDisplayButton from '../../../../components/shared/forms/PPErrorDisplayButton'
import {Location} from 'react-router-dom'

import {Table, TableBody, TableCell, TableRow} from '@mui/material'

interface Props {
    condominiumRepo: NatCondominiumRepo
    condominiumGroupRepo: NatCondominiumGroupRepo
    ridgeRepo: NatRidgeRepo
    roomNumberRepo: NatRoomNumberRepo
    ownershipTransfersRepo: NatOwnershipTransfersRepo,
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    ownershipTransferIssueParams: NatPostOwnershipTransfersParams
    selectedTargetCondominiumInfo: RoomNumberInfo
    dialogOpenSelectCondominium: boolean
    dialogOpenSelectRoomNumber: boolean
}

class NatAdminOwnershipTransfersRegisterPage extends Component<Props & AdminPagePropsSet, States> {

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.state = {
            selectedTargetCondominiumInfo: {
                condominiumCd: '',
                condominiumName: '',
                ridgeCd: '',
                ridgeName: '',
                roomNumber: '',
            },
            ownershipTransferIssueParams: {
                ridgeCd: '',
                roomNumber: '',
                intermediaryName: '',
            },
            dialogOpenSelectCondominium: false,
            dialogOpenSelectRoomNumber: false,
        }
        this.issueButton = this.issueButton.bind(this)
        this.handleCloseCondominiumSelectionDiaLog = this.handleCloseCondominiumSelectionDiaLog.bind(this)
        this.handleCloseRoomNumberSelectionDialog = this.handleCloseRoomNumberSelectionDialog.bind(this)
        this.handleIssueCancelClick = this.handleIssueCancelClick.bind(this)
        this.handleIssueOkClick = this.handleIssueOkClick.bind(this)
        this.handleOpenCondominiumSelectionDialog = this.handleOpenCondominiumSelectionDialog.bind(this)
        this.handleOpenRoomNumberSelectionDialog = this.handleOpenRoomNumberSelectionDialog.bind(this)
        this.setSelectedTargetCondominiumInfo = this.setSelectedTargetCondominiumInfo.bind(this)
        this.setSelectedTargetRoomNumberInfo = this.setSelectedTargetRoomNumberInfo.bind(this)
        this.changeIntermediaryName = this.changeIntermediaryName.bind(this)
    }

    handleOpenCondominiumSelectionDialog(): void {
        this.setState({dialogOpenSelectCondominium: true})
    }

    handleOpenRoomNumberSelectionDialog(): void {
        this.setState({dialogOpenSelectRoomNumber: true})
    }

    handleCloseCondominiumSelectionDiaLog(): void {
        this.setState({dialogOpenSelectCondominium: false})
    }

    handleCloseRoomNumberSelectionDialog(): void {
        this.setState({dialogOpenSelectRoomNumber: false})
    }

    setSelectedTargetCondominiumInfo(selectedCondominiumInfo: CondominiumInfo): void {
        const selectedTargetCondominiumInfo: RoomNumberInfo =
            this.state.selectedTargetCondominiumInfo
        selectedTargetCondominiumInfo.condominiumCd = selectedCondominiumInfo.condominiumCd
        selectedTargetCondominiumInfo.condominiumName = selectedCondominiumInfo.condominiumName

        this.setState({
            selectedTargetCondominiumInfo: selectedTargetCondominiumInfo,
            dialogOpenSelectCondominium: false,
            dialogOpenSelectRoomNumber: true,
        })
    }

    setSelectedTargetRoomNumberInfo(selectedRoomNumberInfo: RoomNumberInfo): void {
        this.setState({
            selectedTargetCondominiumInfo: selectedRoomNumberInfo,
        })
    }

    changeIntermediaryName(event: React.ChangeEvent<HTMLInputElement>): void {
        const ownershipTransferIssueParams: NatPostOwnershipTransfersParams =
            this.state.ownershipTransferIssueParams
        ownershipTransferIssueParams.intermediaryName = event.target.value
        this.setState({ownershipTransferIssueParams: ownershipTransferIssueParams})
    }

    judgeIssueButton(): boolean {
        return !(this.state.selectedTargetCondominiumInfo.ridgeCd &&
            this.state.selectedTargetCondominiumInfo.roomNumber &&
            this.state.ownershipTransferIssueParams.intermediaryName
        )
    }

    renderInputFormTable(): ReactNode {
        return (
            <>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableRowName required>
                                対象物件・部屋番号
                            </TableRowName>
                            <TableCell style={{width: '200px'}}>
                                <LeftRowFlexContainer>
                                    <PPErrorDisplayButton
                                        onClick={this.handleOpenCondominiumSelectionDialog}
                                        eventEmitter={this.props.eventEmitter}
                                        eventKeys={['roomNumber', 'ridgeCd']}
                                    >
                                        物件・部屋番号を選択
                                    </PPErrorDisplayButton>
                                </LeftRowFlexContainer>
                            </TableCell>
                            {this.state.selectedTargetCondominiumInfo &&
                                <TableCell>
                                    {this.state.selectedTargetCondominiumInfo.condominiumCd +
                                        ' ' + this.state.selectedTargetCondominiumInfo.condominiumName}
                                    <br/>
                                    {this.state.selectedTargetCondominiumInfo.ridgeName +
                                        ' ' + convertToRoomNumberForResident(
                                            this.state.selectedTargetCondominiumInfo.roomNumber,
                                        )
                                    }
                                </TableCell>
                            }
                        </TableRow>
                        <TableRow>
                            <TableRowName required>仲介業者名</TableRowName>
                            <TableCell colSpan={3}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 50,
                                        },
                                    }}
                                    style={{width: '400px'}}
                                    value={this.state.ownershipTransferIssueParams.intermediaryName}
                                    onChange={this.changeIntermediaryName}
                                    eventEmitter={this.props.eventEmitter}
                                    eventKeys={['intermediaryName']}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        )
    }

    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={this.judgeIssueButton()}
                        onClick={this.issueButton}
                    >
                        発行する
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        to={`/admin/applications/ownershipTransferList`}
                    >
                        組合員資格変更届一覧へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    handleIssueCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleIssueOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPostOwnershipTransfersParams = {
                ridgeCd: this.state.selectedTargetCondominiumInfo.ridgeCd,
                roomNumber: this.state.selectedTargetCondominiumInfo.roomNumber,
                intermediaryName: this.state.ownershipTransferIssueParams.intermediaryName,
            }

            const response: Nullable<NatPostOwnershipTransfers> =
                await this.props.asyncCallFunction(
                    this.props.ownershipTransfersRepo.issueOwnershipTransfers.bind(
                        this.props.ownershipTransfersRepo,
                        this.state.selectedTargetCondominiumInfo.condominiumCd,
                        request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCC0055.toString('組合員資格変更届')},
                )
            if (response &&
                response.details &&
                response.requestError === null
            ) {
                this.props.navigate(
                    `/admin/condominiums/${this.state.selectedTargetCondominiumInfo.condominiumCd}/applications/ownershipTransfers/${response.details.applyId}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOSTA0001.toString('組合員資格変更届'),
                            },
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async issueButton(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0026.errorLevel,
                message: Messages.IOPCC0026.toString('組合員資格変更届'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleIssueCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleIssueOkClick,
                    },
                ],
            },
        )
    }

    render(): Nullable<ReactElement> {
        return (
            <>
                <PageMainArea>
                    <form>
                        {this.renderInputFormTable()}
                    </form>
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
                {this.state.dialogOpenSelectCondominium &&
                    <NatCondominiumSelectionComponent
                        selectCondominiumType={SELECT_CONDOMINIUM_TYPE.CONDOMINIUM.value}
                        condominiumRepo={this.props.condominiumRepo}
                        condominiumGroupRepo={this.props.condominiumGroupRepo}
                        closeSelectCondominiumDiaLog={this.handleCloseCondominiumSelectionDiaLog}
                        setSelectedCondominiumInfo={this.setSelectedTargetCondominiumInfo}
                        useFunctionId={USE_FUNCTION_ID.OWNERSHIP_TRANSFER}
                        eventEmitter={this.props.eventEmitter}
                        navigate={this.props.navigate}
                        location={this.props.location}
                        asyncCallFunction={this.props.asyncCallFunction}
                        unreleaseCondominiumExclusionFlg={true}
                        title={'対象物件・部屋番号選択（1/2）'}
                        showCloseButton={true}
                    />
                }
                {this.state.dialogOpenSelectRoomNumber &&
                    <NatTargetRoomNumberSelectionComponent
                        ridgeRepo={this.props.ridgeRepo}
                        handleCloseRoomNumberSelectionDialog={this.handleCloseRoomNumberSelectionDialog}
                        handleOpenCondominiumSelectionDialog={this.handleOpenCondominiumSelectionDialog}
                        eventEmitter={this.props.eventEmitter}
                        navigate={this.props.navigate}
                        location={this.props.location}
                        asyncCallFunction={this.props.asyncCallFunction}
                        selectedTargetCondominiumInfo={this.state.selectedTargetCondominiumInfo}
                        roomNumberRepo={this.props.roomNumberRepo}
                        setSelectedTargetRoomNumberInfo={this.setSelectedTargetRoomNumberInfo}
                    />
                }
            </>
        )
    }
}

export default createAdminPage(NatAdminOwnershipTransfersRegisterPage)
